import axios from "../axios";

const api = {
  getNotifications(paramsString, accessToken) {
    const config = {
      headers: {
        "Authorization": `Bearer ${accessToken}`,
        "Skip-Unauthorized-Interceptor": "true"
      }
    };
    return axios.get(`/notifications/questionnaire?${paramsString}`, config).then(({ data }) => data);
  },
  updateNotificationStatus(ids, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.put(`/notifications/questionnaire/status`, ids, headers).then(({ data }) => data);
  }
};

export default api;